import { PosIconProps, SvgWrapper } from './SvgWrapper';

export const BoostIcon = (
  props: Omit<PosIconProps, 'viewBox' | 'fill' | 'stroke'> & {
    inactive?: boolean;
  }
) => {
  return (
    <SvgWrapper
      viewBox="0 0 177 211"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M70.858 11.1519C86.0761 -9.78975 119.193 0.690725 119.592 26.5747L120.195 65.7114H149.21C171.088 65.7117 183.843 90.4099 171.178 108.25L106.794 198.94C91.5979 220.344 57.8839 209.594 57.8834 183.344V144.292H26.9899C4.9753 144.292 -7.74649 119.32 5.19493 101.511L70.858 11.1519ZM108.368 26.7476C108.135 11.6486 88.8163 5.53455 79.9391 17.7505L14.276 108.111L13.9332 108.601C7.07111 118.787 14.1173 132.618 26.3912 133.055L26.9899 133.066H62.3736C66.0933 133.066 69.109 136.082 69.109 139.801V183.344L69.1236 184.055C69.7122 198.613 88.3095 204.543 97.2164 193.013L97.6402 192.442L162.025 101.75C169.297 91.5068 162.201 77.3869 149.804 76.9478L149.21 76.937H115.774L115.431 76.9282C112.024 76.7575 109.277 74.0523 109.053 70.6479L109.039 70.3052L108.368 26.7476ZM86.0318 30.3735C89.4239 25.6225 96.9145 28.0223 96.9147 33.8599V82.6079C96.9147 85.9215 99.6012 88.6077 102.915 88.6079H144.195C149.074 88.6081 151.913 94.123 149.078 98.0942L90.9596 179.499C87.5676 184.25 80.0768 181.85 80.0768 176.012V127.265C80.0768 123.952 77.3903 121.265 74.0768 121.265H32.7965C27.9171 121.265 25.0786 115.75 27.9137 111.779L86.0318 30.3735Z"
        fill={props.inactive ? '#2F343B' : 'url(#paint0_linear_5068_30502)'}
      />
      <defs>
        <linearGradient
          id="paint0_linear_5068_30502"
          x1="34.9194"
          y1="19.211"
          x2="132.36"
          y2="193.257"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#671DE7" />
          <stop offset="1" stopColor="#D4B9FF" />
        </linearGradient>
      </defs>
    </SvgWrapper>
  );
};
